"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecryptESignTokenResponse = exports.CreateESignTokenResponse = exports.AwakeAuthTokenResponse = exports.CreateAuthTokenResponse = void 0;
class CreateAuthTokenResponse {
}
exports.CreateAuthTokenResponse = CreateAuthTokenResponse;
class AwakeAuthTokenResponse {
}
exports.AwakeAuthTokenResponse = AwakeAuthTokenResponse;
class CreateESignTokenResponse {
}
exports.CreateESignTokenResponse = CreateESignTokenResponse;
class DecryptESignTokenResponse {
}
exports.DecryptESignTokenResponse = DecryptESignTokenResponse;
//# sourceMappingURL=auth.js.map